export default __webpack_public_path__ + "static/media/clty.48ab56ad.svg";